// src/components/UserAccessModal.tsx
import React, { useState, KeyboardEvent, useEffect } from 'react';
import { Modal, Button, Form, Badge } from 'react-bootstrap';
import './user-management.modal.scss'; // Import our custom styles
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { getUserList } from '../services/api.service';
import { useParams } from 'react-router-dom';
import { TeamManagementModel } from '../model/team-management.model';
import { UserAccessList, UserRole } from '../model/questions-summary.model';

// Define the types for clarity and type safety




interface UserAccessModalProps {
    show: boolean; // react-bootstrap uses 'show' instead of 'isOpen'
    onHide: () => void; // react-bootstrap uses 'onHide' for closing
    onSubmit: (users: UserAccessList[]) => void;
    initialUsers?: UserAccessList[];
}

// A simple email validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const UserAccessModal: React.FC<UserAccessModalProps> = ({ show, onHide, onSubmit, initialUsers = [] }) => {
    const [users, setUsers] = useState<UserAccessList[]>(initialUsers);
    const [inputValue, setInputValue] = useState<string>('');
    const [currentRole, setCurrentRole] = useState<UserRole>('viewer');
    const [error, setError] = useState<string | null>(null);
    const [team, setTeams] = useState<TeamManagementModel[]>([]);
    const [currentId, setCurrentId] = useState("");
    const { company_id } = useParams<{ company_id: string }>();

    // --- FIX #2: THE CORE OF THE SOLUTION ---
    // This effect now ONLY depends on `show`.
    // It runs when the modal opens or closes.
    useEffect(() => {
        // We only want to reset the state when the modal is OPENED.
        if (show) {
            setError(null);
            setCurrentRole('viewer'); // Also good to reset the role
        }
    }, [show, initialUsers]); // <-- Keeping initialUsers here is OKAY, as long as the parent component stabilizes it (e.g., using useState or useMemo). The logic inside `if(show)` is the most critical part.

    useEffect(() => {
        getAllUser();
    }, [])

    const getAllUser = () => {
        getUserList(company_id).then((res) => {

            if (res.data.message.users) {
                console.log(res.data.message.users);
                setTeams(res.data.message.users)
            }
        })
    }


    const handleChangeEmail = (value) => {
        console.log(value);
        setInputValue(value);
        setCurrentId(value);


    }

    const clickAdd = () => {
        if (currentId && inputValue) {
            const newEmail = team.filter((item) => item.uuid == currentId)[0].email;
            console.log(newEmail);
            if (newEmail) {
                if (!emailRegex.test(newEmail)) {
                    setError(`'${newEmail}' is not a valid email address.`);
                    return;
                }
                if (users.some(user => user.email === newEmail)) {
                    setError(`'${newEmail}' has already been added.`);
                    return;
                }
                setUsers([...users, { email: newEmail, role: currentRole, uuid: currentId }]);
                setInputValue('');
                setCurrentId('');

            }
        }

    }
    const handleChangeRole = (value) => {
        console.log(value);
        setCurrentRole(value);
    }
    const handleRemoveUser = (emailToRemove: string) => {
        setUsers(users.filter(user => user.email !== emailToRemove));
    };

    const handleSubmit = () => {
        onSubmit(users);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>

            <Modal.Body className='user-management-control'>
                <span className='title'>เพิ่มผู้ดูแล</span>
                <p className="text-muted small">
                    เพิ่มผู้ดูแลด้วยอีเมล. ใช้เครื่องหมาย (,) ในการเพิ่มหลายอีเมล
                </p>

                <Form.Group className="mb-3">

                    <div className="d-flex align-items-start gap-2">
                        {/* Custom Tag Input Area */}
                        <div className="form-input-control">


                            <div className='form-email-control'>
                                <div className='d-flex flex-column w-100'>
                                    <Form.Label>ระบุอีเมลและประเภทของผู้ใช้งาน</Form.Label>
                                    <div className='form-field-grid'>

                                        <FormControl
                                            className="input-std form-std-input"
                                            fullWidth
                                        >
                                            <InputLabel id="demo-simple-select-label">User</InputLabel>
                                            <Select
                                                value={inputValue}
                                                variant='outlined'
                                                defaultValue={inputValue}
                                                label="User"
                                                className='job-position-item-input-field'
                                                onChange={e => handleChangeEmail(e.target.value as UserRole)}
                                            >
                                                {
                                                    team.map((item, index) => {

                                                        return (
                                                            <MenuItem value={item.uuid}>{item.firstName} {item.lastName} ({item.email})</MenuItem>
                                                        )
                                                    })
                                                }

                                            </Select>

                                        </FormControl>
                                        <FormControl
                                            className="input-std form-std-input"
                                            fullWidth
                                        >
                                            <InputLabel id="demo-simple-select-label">Role</InputLabel>
                                            <Select
                                                value={currentRole}
                                                variant='outlined'
                                                defaultValue={currentRole}
                                                label="Role"
                                                className='job-position-item-input-field'
                                                onChange={e => handleChangeRole(e.target.value as UserRole)}
                                            >
                                                <MenuItem value="viewer">Viewer</MenuItem>
                                                <MenuItem value="manager">Manager</MenuItem>
                                            </Select>

                                        </FormControl>
                                        <Button className='button-std form-std-input' onClick={clickAdd}>เพิ่ม</Button>
                                    </div>
                                </div>


                            </div>
                            <div className='form-tag-control'>
                                {users.map(user => (
                                    <Badge pill bg="primary" key={user.email} className="button-std form-tag">
                                        <span>{user.email} ({user.role})</span>

                                        <FontAwesomeIcon icon={faClose} className='form-tag-close' onClick={() => handleRemoveUser(user.email)}></FontAwesomeIcon>

                                    </Badge>
                                ))}
                            </div>

                        </div>

                        {/* Role Selector */}

                    </div>
                    {error && <Form.Text className="text-danger">{error}</Form.Text>}
                </Form.Group>
                <div className='button-control'>
                    <Button className='button-cancel' onClick={onHide}>
                        ยกเลิก
                    </Button>
                    <Button variant="primary" className='button-std' onClick={handleSubmit}>
                        ส่งข้อมูล
                    </Button>
                </div>

            </Modal.Body>


        </Modal>
    );
};

export default UserAccessModal;